import { render, staticRenderFns } from "./DovizTakipSekliPicker.vue?vue&type=template&id=36b0f9be"
import script from "./DovizTakipSekliPicker.vue?vue&type=script&lang=ts"
export * from "./DovizTakipSekliPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports